<template>
  <h1 >Associate RFID Tag</h1>
  <audio src="/resources/audio/success.wav" autostart="false" loop="false" hidden="true" width="0" height="0" id="audio_success" />
  <audio src="/resources/audio/error.wav" autostart="false" loop="false" hidden="true" width="0" height="0" id="audio_error" />
  <audio src="/resources/audio/multiple.wav" autostart="false" loop="false" hidden="true" width="0" height="0" id="audio_multiple" />

  <div id="page-rfid-dashboard" class="content-section">
    <div class="page-section">

      <div class="content-section">
        <div class="row">
          <div class="col-md-3">
            <div>
              <FormKit
                  type="button"
                  label="Go Back"
                  input-class="$reset btn-rfid-lg btn btn-rfid btn-associate btn-goback"
                  @click="goTo('Dashboard')"
                  prefix-icon="arrowLeft"
                  prefix-icon-class="btn-rfid-back"
              />
            </div>
          </div>

          <div class="col-md-3">
            <div>
              <FormKit
                  type="button"
                  label="Start Scan"
                  input-class="$reset btn-rfid-lg btn btn-rfid btn-re-assign"
                  @click="goTo('startScan')"
                  :disabled="!canSartScan ? true : false"
                  :help="`Default ${defaultMilisecondsGap} milliseconds gap between scans`"
              />
            </div>

          </div>

          <div class="col-md-3">
            <div>
              <FormKit
                  type="button"
                  label="Stop Scan"
                  input-class="$reset btn-rfid-lg btn btn-rfid btn-assemble"
                  @click="goTo('StopScan')"
                  :disabled="!canStopScan ? true : false"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div>
              <FormKit
                  type="button"
                  label="Reset"
                  input-class="$reset btn-rfid-lg btn btn-rfid btn-associate"
                  @click="goTo('Reset')"
                  :disabled="!canReset ? true : false"
              />
            </div>
          </div>
        </div>
      </div>


      <div class="clearfix"></div>

      <div class="content-section">
        <div class="row">
          <div class="col-md-4">
            <div>
              <FormKit
                  v-model="rAccount.customer_id"
                  type="autocomplete"
                  name="customer_id"
                  id="customer_id"
                  label="Select Account"
                  help="Only accounts that are RFID enabled"
                  placeholder="RFID Accounts"
                  :options="rfidAccounts"
                  @input="onAccountChange"
                  open-on-click
                  clear-search-on-open
                  searchable
              />
            </div>

            <div v-if="!showEmptyGarment">
              <FormKit
                  v-model="accountGarment.garmenttype_id"
                  type="autocomplete"
                  name="garmenttype_id"
                  id="garmenttype_id"
                  label="Select Garment"
                  placeholder="Select Garment"
                  :options="accountGarments"
                  @input="onGarmentChange"
                  open-on-click
                  clear-search-on-open
                  searchable
                  :key="selectOptionClearedKey"
              />
            </div>
            <div v-if="!showEmptyGarment">
              <FormKit
                  v-model="accountGarmentService.service_id"
                  type="autocomplete"
                  name="service_id"
                  id="service_id"
                  label="Select Service"
                  placeholder="Select Service"
                  :options="accountGarmentServices"
                  @input="onGarmentServiceChange"
                  open-on-click
                  clear-search-on-open
                  searchable
                  :key="selectOptionClearedKey"
              />
            </div>
            <div v-if="showEmptyGarment" class="row">
              <label class="formkit-label">Select Garment</label>
              <div class="error-message">No Custom Garments</div>
              <div class="col-md-6">
                <FormKit
                    type="button"
                    label="Create"
                    help="Opens in new tab"
                    input-class="$reset btn-rfid-sm btn btn-rfid btn-re-assign"
                    @click="goTo('NewGarment')"
                />
              </div>
              <div class="col-md-6">
                <FormKit
                    type="button"
                    label="Refresh"
                    input-class="$reset btn-rfid-sm btn btn-rfid btn-pieceup"
                    @click="goTo('RefreshGarment')"
                />
              </div>
            </div>


            <div>
              <FormKit
                  type="button"
                  label="Apply to All"
                  input-class="$reset btn-rfid-lg btn btn-rfid btn-bundling"
                  :disabled="!canApply ? true : false"
                  @click="goTo('ApplyAll')"
              />
            </div>
          </div>

          <div class="col-md-8">

            <div class="alert alert-success" v-if="showapplyMessage" >
              <!-- The ok message after Apply All was made will be populated here -->
              {{applyMessage}}
            </div>

            <div class="alert alert-danger" id="events" v-if="showSseErrors || showapplyErrors"  >
              <!-- Events Errors (from go SSE) will be populated here -->
              <!-- OR  Apply All Errors will be populated here -->
              <template v-if="showSseErrors">
                {{sseErrors}}
              </template>
              <template v-else>
                {{applyErrors}}
              </template>
            </div>

            <div class="alert alert-success"  v-if="canStopScan || restoreLocalStorage" >
              <!-- The ok message after Apply All was made will be populated here -->
              Count: {{tagsScanned.length}} tags scanned
            </div>
            <div style="max-height: 500px; overflow: auto;">
              <easy-data-table
                  :headers="headers"
                  :items="sortedItems"
                  :row-class-name="getRowClass"
                  :rows-per-page="99999"
                  alternating
                  border-cell
                  hide-footer
              >
                <template #item-action="item">
                  <button class="btn btn-sm btn-danger float-right" @click="removeScannedItem(item)">&#10006;</button>
                </template>
              </easy-data-table>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>

  <div class="modal" tabindex="-1" id="showAlertMessagesModal" ref="showAlertMessagesModal" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Attention!</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="alert alert-warning" >
            <div v-html="alertMessage"></div>
          </div>
          <div v-if="hasLocalStorage">
            <div class="alert alert-danger" v-if="error_message">
              <div v-html="error_message"></div>
            </div>
            <FormKit
                v-model="uniquepw"
                type="password"
                name="uniquepw"
                id="uniquepw"
                label="Manager Pin"
                placeholder="Manager Pin"
                validation="required"
            />
          </div>
        </div>
        <div class="modal-footer">
          <div v-if="hasLocalStorage">
            <div style="  float: left;">
              <button type="button" class="btn btn-success"  @click="allowLocalStorage">Restore</button>
            </div>
            <div style="  float: right;margin-left: 30px;">
              <button  type="button" class="btn btn-primary" @click="deleteLocalStorage">
                Clear and start fresh
              </button>
            </div>
          </div>
          <div v-else-if="hasMultipleScans">
            <div style="  float: left;">
              <button type="button" class="btn btn-success"  @click="allowMultipleScans">Add</button>
            </div>
            <div style="  float: right;margin-left: 30px;">
              <button  type="button" class="btn btn-primary" @click="deleteMultipleScans">
                Try Again
              </button>
            </div>
          </div>
          <div v-else-if="hasAlreadyRegistered">
            <div style="  float: left;">
              <button type="button" class="btn btn-warning"  @click="allowAlreadyRegistered">Overwrite</button>
            </div>
            <div style="  float: right;margin-left: 30px;">
              <button  type="button" class="btn btn-primary" @click="deleteAlreadyRegistered">
                Remove and Try Again
              </button>
            </div>
          </div>
          <div v-else>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">OK</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>


<script setup>

import {onMounted, ref, computed, inject, reactive, watch, onBeforeUnmount} from 'vue'
import 'bootstrap/dist/css/bootstrap.min.css';
import VueCookies from "vue-cookies";
import RFIDService from "@/services/RFIDService";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle";
import { useRouter, useRoute, onBeforeRouteLeave } from 'vue-router';


import { timeDiff, formatLondon } from '@/utils/dateUtils';
import { closeModal, openModal } from '@/utils/modalUtils';

const rfidAccounts = ref([]);
const uniquepw  = ref("");
const accountGarments = ref([]);
const accountGarmentServices = ref([]);
const canApply  = ref(false);
const canSartScan  = ref(true);
const canStopScan  = ref(false);
const canReset  = ref(false);
const restoreLocalStorage  = ref(false);
const isRestoringFromLocalStorage  = ref(false);
const isOneGarmentService  = ref(false);
const showEmptyGarment  = ref(false);
var eventSource = {
  close: function() {
    console.log('initialized');
  }
};
const showSseErrors  = ref(false);
const sseErrors  = ref('');
const lastTimestamp  = ref(new Date());
const defaultMilisecondsGap  = ref(200);
const showapplyMessage  = ref(false);
const applyMessage  = ref('');
const showapplyErrors  = ref(false);
const applyErrors  = ref('');
const rAccount = ref({
  customer_id: 0,
  fullname: "",
});
const accountGarment = ref({
  garmenttype_id: 0,
  fullname: "",
});
const accountGarmentService = ref({
  service_id: 0,
  fullname: "",
});
const selectOptionClearedKey = ref(0);

const alertMessage = ref('');
const error_message = ref('');
const showAlertMessagesModal = ref(null);
const hasMultipleScans = ref(false);
const hasAlreadyRegistered = ref(false);
const hasLocalStorage = ref(false);
const lastScan = ref({});
const rfidStorageDetails = ref({
  username: JSON.parse(localStorage.getItem('sessionDetails')).username || "",
  tagsScanned: [],
  lastScan: {},
  rAccount: {
    fullname: "",
    customer_id: 0,
  },
  accountGarment: {
    fullname: "",
    garmenttype_id: 0,
  },
  accountGarmentService: {
    fullname: "",
    service_id: 0,
  },
});
const currentScan =  ref([]);
const tagsScanned =  ref([]);
const tempTagsScanned =  ref([]);
const multipleTagsScanned =  ref([]);
const tempMultipleTagsScanned = ref([]);
const tagsApplied =  ref([]);
const headers = [
  { text: "Index", value: "garmentindex", sortable: false  },
  { text: "EPC Scanned", value: "epcscanned", sortable: false },
  { text: "Timestamp", value: "tagtimestamp", sortable: false, align: "d-none" },
  { text: "", value: "action", sortable: false },
];
const sortedItems = computed(() =>
    [...tagsScanned.value].sort((a, b) => b.garmentindex - a.garmentindex)
);
const getRowClass = (row) => {

  console.log("getRowClass", row);
  return row.isNew ? 'highlight-row' : ''
};

const zeroPad = (num, places) => String(num).padStart(places, '0')

const playSound = (soundtype) => {
  let sound = document.getElementById("audio_"+soundtype);
  sound.currentTime = 0;
  sound.loop = false;
  sound.play();
}
const resetLocalStorage = () => {
  //reset localStorage
  localStorage.removeItem('RFID_details');
  const sessionDetails = JSON.parse(localStorage.getItem('sessionDetails'));
  rfidStorageDetails.value = {
    username: sessionDetails.username || "",
    tagsScanned: [],
    lastScan: {},
    rAccount: {
      fullname: "",
      customer_id: 0,
    },
    accountGarment: {
      fullname: "",
      garmenttype_id: 0,
    },
    accountGarmentService: {
      fullname: "",
      service_id: 0,
    },
  };
}

// When user selects a new account
const onAccountChange = async (customerId) => {
  rAccount.value.customer_id = customerId;

  const selectedAccount = rfidAccounts.value.find(
      // {label: 'Surname-16 Firstname-16', value: '__mask_1', __original: 16}
      account => Number(account.__original) == Number(customerId)
  );

  if (selectedAccount) {
    rAccount.value.fullname = selectedAccount.label;
  }

  await refreshgarment();
  // Optionally reset garment and service
  if (!isRestoringFromLocalStorage.value) {
    accountGarment.value.garmenttype_id = 0;
    accountGarmentService.value.service_id = 0;
  }

  rfidStorageDetails.value.rAccount.customer_id = rAccount.value.customer_id;
  rfidStorageDetails.value.rAccount.fullname = rAccount.value.fullname;
  localStorage.setItem('RFID_details', JSON.stringify(rfidStorageDetails.value));
};

// When user selects a new garment
const onGarmentChange = async (garmenttypeId) => {
  accountGarment.value.garmenttype_id = garmenttypeId;

  const selectedGarment = accountGarments.value.find(
      // {label: 'Surname-16 Firstname-16', value: '__mask_1', __original: 16}
      garment =>  Number(garment.__original) == Number(garmenttypeId)  || Number(garment.value) == Number(garmenttypeId)
  );

  if (selectedGarment){
    accountGarment.value.fullname = selectedGarment.label || "";
  }

  await refreshgarmentservice();

  rfidStorageDetails.value.accountGarment.garmenttype_id = accountGarment.value.garmenttype_id;
  rfidStorageDetails.value.accountGarment.fullname = accountGarment.value.fullname;
  localStorage.setItem('RFID_details', JSON.stringify(rfidStorageDetails.value));
};

// When user selects a new garment service
const onGarmentServiceChange = async (serviceId) => {
  accountGarmentService.value.service_id = serviceId;

  const selectedService = accountGarmentServices.value.find(
      // {label: 'Surname-16 Firstname-16', value: '__mask_1', __original: 16}
      service => Number(service.__original) == Number(serviceId) || Number(service.value) == Number(serviceId)
  );

  if (selectedService) {
    accountGarmentService.value.fullname = selectedService.label || "";
  }

  rfidStorageDetails.value.accountGarmentService.service_id = accountGarmentService.value.service_id;
  rfidStorageDetails.value.accountGarmentService.fullname = accountGarmentService.value.fullname;
  localStorage.setItem('RFID_details', JSON.stringify(rfidStorageDetails.value));
};

// Function to show alert messages based on the type
function showAlert(type, message) {
  hasMultipleScans.value = false;
  hasAlreadyRegistered.value = false;
  hasLocalStorage.value = false;
  if (type === 'multiple') hasMultipleScans.value = true;
  if (type === 'already') hasAlreadyRegistered.value = true;
  if (type === 'localstorage') hasLocalStorage.value = true;
  alertMessage.value = message;
  openModal(showAlertMessagesModal);
}
const removeScannedItem = (item) => {
  // Remove from tagsScanned.value
  const scannedIndex = tagsScanned.value.findIndex(tag => tag.epcscanned === item.epcscanned);
  if (scannedIndex !== -1) {
    tagsScanned.value.splice(scannedIndex, 1);
    // Reset garmentindex for all remaining items
    tagsScanned.value.forEach((tag, idx) => {
      tag.garmentindex = String(idx + 1).padStart(3, '0');
    });
  }
  //update local storage
  storeTagsToLocalStorage()
};
const refreshgarment = async () => {

  //reset garmenttype and service
  accountGarments.value = [];
  accountGarment.value = { garmenttype_id: 0, fullname: "" };
  showEmptyGarment.value = false;
  accountGarmentService.value = { service_id: 0, fullname: "" };
  accountGarmentServices.value = [];

  if (rAccount.value.customer_id > 0) {
//get the garments type for selected account
  return RFIDService.getAccountGarmentType(rAccount.value.customer_id)
      .then(response => {
        const garments = response.data.data.garmentstype;

        if (garments.length == 0) {
          showEmptyGarment.value = true;
          accountGarments.value = [];
          accountGarment.value = { garmenttype_id: 0, fullname: "" };
        } else {
          showEmptyGarment.value = false;
          const newGarments = garments.map((g) => ({
            label: g.garment_details.garmenttype,
            value: g.garmenttype_id,
          }));
          newGarments.unshift({
            label: " - select garment - ",
            value: "0"
          });

          accountGarments.value = newGarments;
        }

      })
      .catch(e => {
        console.log(e);
      });
  } else {
    return false;
  }
  
}
const refreshgarmentservice = async () => {

  isOneGarmentService.value = false;
  accountGarmentService.value = { service_id: 0, fullname: "" };
  accountGarmentServices.value = [];

  return RFIDService.getAccountGarmentTypeService(accountGarment.value.garmenttype_id)
      .then(response => {
        const services = response.data.data.service_prices;

        if (services.length == 0) {
          accountGarmentServices.value = [{
            label: " - select service - ",
            value: 0
          }];
          accountGarmentService.value = {
            service_id: 0,
            fullname: "",
          };
        } else {
          accountGarmentServices.value = services.map((response) => {
            return {
              label: response.servicetype,
              value: response.servicetype_id,
            }
          });
          accountGarmentServices.value.unshift({
            label: " - select service - ",
            value: 0
          });

          const realServicesCount = services.length;
          if (realServicesCount === 1 && !isRestoringFromLocalStorage.value) {
            // Auto-select the only service
            accountGarmentService.value.service_id = services[0].servicetype_id;
            accountGarmentService.value.fullname = services[0].servicetype;
            isOneGarmentService.value = true;
          } else if (!isRestoringFromLocalStorage.value) {
            // Reset if not restoring and not exactly one service
            accountGarmentService.value.service_id = 0;
            accountGarmentService.value.fullname = "";
          }
        }
      })
      .catch(e => {
        console.log(e);
      });
}
const allowLocalStorage = async () => {

  // Check if the user has entered the correct unique password
  let epos_userid = VueCookies.get('epos2_userid');
  //let epos_username = VueCookies.get('epos2_username');
  RFIDService.checkManagerByPin(epos_userid, uniquepw.value)
      .then(async response => {
        if (response.data.success === true) {
          const loaded = JSON.parse(localStorage.getItem('RFID_details'));
          if (loaded && loaded.tagsScanned && loaded.tagsScanned.length > 0) {
            restoreLocalStorage.value = true;
            rfidStorageDetails.value = loaded;
            tagsScanned.value = loaded.tagsScanned;
            lastScan.value = loaded.lastScan || {};
            lastTimestamp.value = new Date(loaded.lastTimestamp || new Date());

            isRestoringFromLocalStorage.value = true;
            // 1. Set customer_id and wait for garments to load
            if (loaded.rAccount && loaded.rAccount.customer_id) {
              rAccount.value.customer_id = loaded.rAccount.customer_id;
              await refreshgarment();
            }

            // 2. Set garmenttype_id and wait for services to load
            if (loaded.accountGarment && loaded.accountGarment.garmenttype_id) {
              accountGarment.value.garmenttype_id = loaded.accountGarment.garmenttype_id;
              await refreshgarmentservice();
            }

            // 3. Set service_id
            if (loaded.accountGarmentService && loaded.accountGarmentService.service_id) {
              accountGarmentService.value.service_id = loaded.accountGarmentService.service_id;
            }
            isRestoringFromLocalStorage.value = false;
          }
          addToScanList( tagsScanned.value, false);
          closeModal(showAlertMessagesModal);
        } else {
          error_message.value = "Incorrect Manager Pin";
          return false
        }
      })
      .catch(e => {
        error_message.value = "Incorrect Manager Pin";
        console.log(e);
        return false
      });
}
const deleteLocalStorage = async () => {
  let epos_userid = VueCookies.get('epos2_userid');
  RFIDService.checkManagerByPin(epos_userid, uniquepw.value)
      .then(response => {
        if (response.data.success === true) {
          restoreLocalStorage.value = false;
          // Clear localStorage
          resetLocalStorage();
          closeModal(showAlertMessagesModal);
        } else {
          console.log("Incorrect Manager Pin");
          error_message.value = "Incorrect Manager Pin";
          return false
        }
      })
      .catch(e => {
        error_message.value = "Incorrect Manager Pin";
        console.log(e);
        return false
      });
}
const allowMultipleScans = async () => {
  //add all lines from multipleTagsScanned to the tagsScanned list
  if (multipleTagsScanned.value.length > 0) {
    multipleTagsScanned.value.forEach((item) => {
      addToScanList(item, false);
      addTempScanList(item);
    });
    multipleTagsScanned.value= [];
    hasMultipleScans.value = false;

    closeModal(showAlertMessagesModal);
  }
}
const deleteMultipleScans = async () => {
  multipleTagsScanned.value= [];
  tempTagsScanned.value= [];
  //delete last entry from tagsScanned
  if (tagsScanned.value.length > 0) {
    tagsScanned.value.pop();
  }
  storeTagsToLocalStorage();
  hasMultipleScans.value = false;
  closeModal(showAlertMessagesModal);
}
const allowAlreadyRegistered = async () => {
  addToScanList(lastScan.value, false);
  hasMultipleScans.value = false;
  alertMessage.value = "";
  closeModal(showAlertMessagesModal);
}
const deleteAlreadyRegistered = async () => {
  lastScan.value = {};
  hasMultipleScans.value = false;
  alertMessage.value = "";
  closeModal(showAlertMessagesModal);
}
 const storeTagsToLocalStorage = async () => {
  // Save to localStorage as JSON
  rfidStorageDetails.value.tagsScanned = tagsScanned.value;
  localStorage.setItem('RFID_details', JSON.stringify(rfidStorageDetails.value));
 }

// Function to add a scanned tag to the list -
// the one that will be displayed in the table and submitted to the server
const addToScanList = async (sseData, needSound = true) => {
  let gindex = tagsScanned.value.length + parseInt(1);
  let tagCurrentTimestamp = formatLondon(sseData.timestamp);

  if (sseData.tag === undefined || sseData.tag === null || sseData.tag === "") {
    //console.error("EPC Tag is empty or undefined");
    return false;
  }
  tagsScanned.value.push({
    garmentindex: zeroPad(gindex, 3), epcscanned: sseData.tag,
    tagtimestamp: tagCurrentTimestamp,
    isNew: true
  });
  tagsScanned.value = [...tagsScanned.value];
  // Set isNew to false after 1 second
  setTimeout(() => {
    const lastIndex = tagsScanned.value.length - 1;
    if (lastIndex >= 0) {
      tagsScanned.value[lastIndex].isNew = false;
      tagsScanned.value = [...tagsScanned.value];
    }
  }, 3000);

  rfidStorageDetails.value.lastScan = sseData;
  // Save to localStorage as JSON
  storeTagsToLocalStorage();
  //rfidStorageDetails.value.tagsScanned = tagsScanned.value;
  //localStorage.setItem('RFID_details', JSON.stringify(rfidStorageDetails.value));
  if (needSound) {
    playSound('success');
  }
  lastTimestamp.value = sseData.timestamp;
}
// Function to add a scanned tag to the temporary list -
// the one that will be used to check for multiple scans
const addTempScanList = async (sseData) => {
  let gindex = tempTagsScanned.value.length + parseInt(1);
  let tagCurrentTimestamp = formatLondon(sseData.timestamp);

  tempTagsScanned.value.push({
    garmentindex: zeroPad(gindex, 3), epcscanned: sseData.tag,
    tagtimestamp: tagCurrentTimestamp
  });
}
// Function to add a scanned tag to the multiple tags list -
// the one that will be used to check for multiple scans
const addToMultipleList = async (sseData) => {
  multipleTagsScanned.value.push(sseData);
}

//Function checks if there are any two tags scanned within 10 miliseconds (defaultMilisecondsGap.value)
const checkMultipleScan = async() => {
  let found = false;
  if (tempTagsScanned.value.length < 1) {
    return false; // No pairs to compare
  }
  tempMultipleTagsScanned.value = multipleTagsScanned.value;

  //get last timestamp from tempTagsScanned
  let lastEntry = tempTagsScanned.value[tempTagsScanned.value.length - 1];
  //add lastTimestamp to multipleTagsScanned
  tempMultipleTagsScanned.value.push(lastEntry);

  for (let i = 0; i < tempMultipleTagsScanned.value.length; i++) {
    for (let j = i + 1; j < tempMultipleTagsScanned.value.length; j++) {
      let diff = timeDiff(tempMultipleTagsScanned.value[i].tagtimestamp, tempMultipleTagsScanned.value[j].tagtimestamp);
      if (diff && Number(diff) < Number(defaultMilisecondsGap.value)) {
        found = true;
        break;
      }
    }
    if (found) break;
  }
  return found;
}


const handleScan = async (sseData) => {
  const hasMultiple = await checkMultipleScan();
  if (hasMultiple) {
    addToMultipleList(sseData);
    // At least one pair of scans is less than defaultMilisecondsGap.value ms apart
    //show dialog box
    playSound('multiple');
    alertMessage.value = "Multiple scans detected, please check!";
    hasMultipleScans.value = true;
    showAlert('multiple', "Multiple scans detected, please check!");
    openModal(showAlertMessagesModal);

    return false;
  } else {
    hasMultipleScans.value = false;
    addToScanList(sseData);
  }
};

// Function to handle stream events from the server and process the incoming RFID tags
const startServerStream = async() => {
  sseErrors.value = "";
  const authToken = VueCookies.get('epos2_token');

  eventSource = new EventSource(process.env.VUE_APP_GO_API_BASE+"/api/rfid/stream?token=" + authToken);
  eventSource.onmessage = (event) => {

    //extend cookies expiration
    pingSession();

    if (event.data && event.data.includes('heartbeat')) {
      // Handle heartbeat event
      sseErrors.value = "";
      showSseErrors.value = false;

      return; // Don't process as normal data
    }
    const sseData = JSON.parse(event.data);

    hasMultipleScans.value = false;
    hasAlreadyRegistered.value = false;
    if (!sseData.success) {
      if (sseData.data)
      {
        //show dialog box
        playSound('error');
        lastScan.value = sseData;
        currentScan.value = sseData;
        alertMessage.value = "RFID EPC Tag already registered in the system." + "<br><br>"
            + "GarmentID: <a href='/garments/"+sseData.data.garment_id+"'  target='_blank'>"+sseData.data.garment_id+"</a><br>"
            + "Customer Name: <a href='/customers/"+sseData.data.customer_id+"'  target='_blank'>"+sseData.data.customer_name+"</a><br>"
            + "Garment Type: <a href='/garmenttype/"+sseData.data.garment_type_id+"'  target='_blank'>"+sseData.data.garment_type+"</a><br>";
        //hasAlreadyRegistered.value = true;
        showAlert('already',alertMessage.value);
        openModal(showAlertMessagesModal);
        return false;
      }
      else {
        showSseErrors.value = true;
        sseErrors.value = sseData.error;
      }

    } else {
      showSseErrors.value = false;
      sseErrors.value = "";
      //remove duplicates (same tag)
      let tagCheck = tagsScanned.value.findIndex((item) => item.epcscanned === sseData.tag);
      if (tagCheck === -1) {
        addTempScanList(sseData);

        lastScan.value = sseData;
        currentScan.value = sseData;

        handleScan(sseData);
      } else {
        console.log("Tag already exists");
      }
    }
  };
  eventSource.onerror = function(error) {
    //playSound('error');
    console.error("Error:", error);
    sseErrors.value =  "An error occurred. Session still active?";
    showSseErrors.value = true;
  };
  eventSource.addEventListener("open", function(event) {
    console.log("Stream connection opened");
  });
}
const startScan = async () => {
  console.log("start scan");
  //call goapi endpoint in order to start the scan
  canSartScan.value = false;
  canApply.value = false;
  canStopScan.value = true;
  canReset.value = true;
  showapplyMessage.value = false;
  applyMessage.value = "";
  showapplyErrors.value = false;
  applyErrors.value = "";

  startServerStream();

  //start the reader to read the tags
  RFIDService.startScan(rAccount.value.customer_id)
      .then(response => {
      })
      .catch(e => {
        console.log(e);
      });
}
const stopScan = async () => {
  console.log("Stop scan");
  canSartScan.value = true;
  canStopScan.value = false;
  //call goapi endpoint in order to stop the reader and finish to populate the table of founded tags
  canApply.value = true;
  //if(eventSource && eventSource.readyState === 1){
  if(eventSource){
    eventSource.close()
  }
  showSseErrors.value = false;
  sseErrors.value = "";
  RFIDService.stopScan(rAccount.value.customer_id)
      .then(response => {

      })
      .catch(e => {
        console.log(e);
      });
}
const resetScan = async () => {
  //stop the scan and clear the page
  stopScan();

  tagsScanned.value = [];
  localStorage.setItem('RFID_details', []);
  accountGarment.value = {
    fullname: "",
    garmenttype_id: 0,

  }
  accountGarmentService.value = {
    fullname: "",
    service_id: 0,

  };
  accountGarmentServices.value = [];

  rAccount.value = {
    fullname: "",
    customer_id: 0,

  };

  canStopScan.value = false;
  canSartScan.value = true;

  canApply.value = false;

  showapplyMessage.value = false;
  applyMessage.value = "";
  showapplyErrors.value = false;
  applyErrors.value = "";
  multipleTagsScanned.value = [];
  tempTagsScanned.value = [];
  tagsScanned.value = [];
  tagsApplied.value = [];
  storeTagsToLocalStorage();

  lastScan.value = {};
  currentScan.value = {};
  //clear localStorage
  resetLocalStorage();
  hasMultipleScans.value = false;
}

const applyAll = async () => {

  alertMessage.value = "";
  error_message.value = "";
  closeModal(showAlertMessagesModal);

  //check if both Customer Account and Garment Type are selected
  console.log(rAccount.value.customer_id );
  console.log( accountGarment.value.garmenttype_id );
  if (rAccount.value.customer_id == 0 || accountGarment.value.garmenttype_id == 0) {

    alertMessage.value = "Please select Account and Garment";
    openModal(showAlertMessagesModal);
    return false;
  }
  if (tagsScanned.value.length == 0) {
    alertMessage.value = "No tags scanned yet";
    openModal(showAlertMessagesModal);
    return false;
  }
  tagsScanned.value.forEach(function (item) {
    tagsApplied.value.push({
      tag_id: item.epcscanned,
      garmenttype_id: accountGarment.value.garmenttype_id,
      default_service: accountGarmentService.value.service_id,
      tag_type: "rfid",
      created_at: item.tagtimestamp,
    });
  });

  showapplyMessage.value = false;
  applyMessage.value = "";
  showapplyErrors.value = false;
  applyErrors.value = "";

  //apply all and after that resetScan
  RFIDService.applyAllCustomerGarments(rAccount.value.customer_id, tagsApplied.value)
      .then(response => {
        if (response.data.success == "true" || response.data.success === true) {

          resetScan();
          showapplyMessage.value = true;
          applyMessage.value = response.data.message;
        }
        else {
          showapplyErrors.value = true;
          applyErrors.value = response.data.message;
          console.log(response);
        }
      })
      .catch(e => {
        console.log(e);
      });


}
const goTo = (pageSection) =>   {
  switch (pageSection) {
    case "Dashboard":
      window.open(
          "/rfid/dashboard",
          "_self"
      );
      break;
    case "NewGarment":
      window.open(
          "/garmenttype",
          "_blank"
      );
      break;
    case "RefreshGarment":
      refreshgarment();
      break;
    case "startScan":
      startScan();
      break;
    case "StopScan":
      stopScan();
      break;
    case "Reset":
      resetScan();
      break;
    case "ApplyAll":
      applyAll();
      break;
  }
}
const loadrfidAccounts = async () => {
  // Get all accounts that have parameter rfid_account = 1
  //fullname customer_id for autocomplete
  RFIDService.getRFIDAccounts()
      .then(response => {
        const rAccounts = response.data.data.customers;

        rfidAccounts.value = rAccounts.map((response) => {
          return {
            label: response.surname+' '+response.firstname,
            value: response.customerid,
          }
        });
        rfidAccounts.value.unshift({
          label: " - select account - ",
          value: "0"
        });
      })
      .catch(e => {
        console.log(e);
      });
}
function pingSession() {
  let userId = VueCookies.get('epos2_userid');
  let idToken = VueCookies.get('epos2_token');
  let userWorkstation = VueCookies.get('epos2_workstationid');

        VueCookies.set('epos2_token',idToken);
        VueCookies.set('epos2_userid',userId);
        VueCookies.set('epos2_workstationid',userWorkstation);
  console.log('API called at', new Date());
}
onMounted(async () => {
  // Load accounts that have parameter rfid_account = 1
  loadrfidAccounts();
  showAlertMessagesModal.value = new bootstrap.Modal('#showAlertMessagesModal', {})

  window.addEventListener('beforeunload', handleBeforeUnload);

  const storedRFID = JSON.parse(localStorage.getItem('RFID_details'));
  //check if localStorage has RFID details
  if (storedRFID && storedRFID.tagsScanned && Array.isArray(storedRFID.tagsScanned) && storedRFID.tagsScanned.length > 0) {
    // storedRFID is set and not empty
    rfidStorageDetails.value = storedRFID;
    alertMessage.value = "<b>Unsaved Tags found in the system. Click Restore to continue with them.</b>" + "<br><br>"
        + "Scanned by: "+rfidStorageDetails.value.username+"<br>"
        + "No of Tags Scanned: "+rfidStorageDetails.value.tagsScanned.length+"<br>"
        + "Customer Name: <a href='/customers/"+rfidStorageDetails.value.rAccount.customer_id+"'  target='_blank'>"+rfidStorageDetails.value.rAccount.fullname+"</a><br>"
        + "Garment Type: <a href='/garmenttype/"+rfidStorageDetails.value.accountGarment.garmenttype_id+"'  target='_blank'>"+rfidStorageDetails.value.accountGarment.fullname+"</a><br>"
        + "Service: "+rfidStorageDetails.value.accountGarmentService.fullname+"<br>";

    accountGarmentServices.value = [];

    showAlertMessagesModal.value.show()
    hasLocalStorage.value = true;

  } else {
    // storedRFID is not set or is empty
  }

});

onBeforeUnmount(() => {

  
  // This will only run if the user actually leaves the page
  if (canStopScan.value) {
    stopScan();
  }
  window.removeEventListener('beforeunload', handleBeforeUnload);
});

//the beforeunload event only triggers on browser refresh, tab close, or direct navigation
// (not on in-app navigation like clicking Vue Router links or menu icons).
const handleBeforeUnload = (event) => {
  if (canStopScan.value) {
    // Use fetch with keepalive for a PUT request
    fetch(
        `${process.env.VUE_APP_GO_API_BASE}/api/rfid/stop-reader?token=${VueCookies.get('epos2_token')}`,
        {
          method: 'PUT',
          keepalive: true,
        }
    );
    // Show browser confirmation dialog
    event.preventDefault();
    event.returnValue = 'A scan is in progress. Are you sure you want to leave?';
    // The browser will show a confirmation dialog.
    // If the user confirms, the page will unload and onBeforeUnmount will be called,
    // where stopscan() will be executed.
    return 'A scan is in progress. Are you sure you want to leave?';
  }
};
//prompt the user and stop the scan when navigating away via Vue Router
onBeforeRouteLeave((to, from, next) => {
  if (canStopScan.value) {
    if (window.confirm('A scan is in progress. Are you sure you want to leave?')) {
      stopScan();
      next();
    } else {
      next(false);
    }
  } else {
    next();
  }
});

</script>


<style scoped>
.main-section > h1:first-child {
  background: var(--associate-tag-bg-color);
}
.error-message {
  color: var(--red-color);
  font-weight: bold;
}
.highlight-row {
  background-color: #ffeeba !important; /* or any highlight color */
  transition: background-color 0.5s;
}
</style>
